import { previewCardEntry as rTextCardEntry } from '../components/r-text/preview-card-entry';
import { previewCardEntry as cloudinaryAdvancedImageCardEntry } from '../components/cloudinary-advanced-image/preview-card-entry';
import { previewCardEntry as rVideoCardEntry } from '../components/r-video/preview-card-entry';
import { previewCardEntry as rIconCardEntry } from '../components/r-icon/preview-card-entry';
import { previewCardEntry as rButtonCardEntry } from '../components/r-button/preview-card-entry';
import { previewCardEntry as rDividerCardEntry } from '../components/r-divider/preview-card-entry';
import { previewCardEntry as rEmbedCardEntry } from '../components/r-embed/preview-card-entry';
import { previewCardEntry as rListCardEntry } from '../components/r-list/preview-card-entry';
import { previewCardEntry as rAccordionCardEntry } from '../components/r-accordion/preview-card-entry';
import { previewCardEntry as rMountCardEntry } from '../components/r-mount/preview-card-entry';
import type { EditorPreviewCardEntry } from '@source-components-react/types';

export const cardEntries: EditorPreviewCardEntry[] = [
  rTextCardEntry,
  cloudinaryAdvancedImageCardEntry,
  rVideoCardEntry,
  rIconCardEntry,
  rButtonCardEntry,
  rDividerCardEntry,
  rEmbedCardEntry,
  rListCardEntry,
  rAccordionCardEntry,
  rMountCardEntry,
];
